<template>

    <div v-if="showMe">
        
        <v-row id="sd-widj-box">
            <v-col id="left-box" class="text-center" cols="3">
                <v-row class="my-auto" align="center" justify="center">
                    <v-col>
                        Sudden<br />Death
                    </v-col>
                </v-row>
            </v-col>

            <v-col id="right-box" class="py-0" cols="9">
                <v-row id="right-top-box">
                    <v-col class="text-center" cols="12">
                        Game {{ weekInfo.sd_game_num }}, Round {{ weekInfo.sd_round }}. 
                        <span v-html="numSurvivors"></span>
                    </v-col>
                </v-row>
                <v-row id="right-bottom-box">
                    <v-col class="text-center" cols="12">
                        <div>
                            <div v-if="isAlive">
                                <div v-if="hasPicked">
                                    You've picked {{ getTeamPicked }}
                                    <v-btn class="link-btn float-right" color="primary" small elevation="2" @click="$router.push('sudden-death')" v-if="!deadlineHasPassed">Edit</v-btn>
                                </div>
                                <div v-else>
                                    <div v-if="!deadlineHasPassed">
                                        <v-btn color="danger" small block dark elevation="2" @click="$router.push('sudden-death')">No team picked - PICK NOW!</v-btn>
                                    </div>
                                    <div v-else>
                                        No team picked. Oh dear.
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                You're Dead!
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

    </div>

</template>

<script>

import {mapGetters} from "vuex";
import moment from 'moment';

export default {
    name: "SuddenDeathWidgetTwo",
    props: [
      //
    ],
    components: {
      //
    },
    data: () => ({
        showMe: false,
        pickedTeam: null,
    }),
    computed: {
        ...mapGetters([
            'currentGame',
            'weekGames',
            'weekInfo',
            'weeks',
            'user'
        ]),
        userPicks() {
            if (this.currentGame) {
                return this.currentGame.picks.filter(pick => pick.user_id === this.user.id);
            }
        },
        deadline() {
            if (this.weekGames) {
                const mindate =  Math.min.apply(Math, this.weekGames.map( obj => moment(obj.kickoff_datetime)))
                return moment(mindate);
            }
        },
        deadlineHasPassed() {
            let now = moment();
            return now > this.deadline;
        },
        isAlive() {
            //either: first week of game OR prev week pick was a winner - NEED PLAY WEEK
            if (this.weekInfo.sd_round === 1) {
                return true;
            } else {
                if (!this.userPicks) {
                    return false;
                } else {
                    let prev = this.currentGame.picks.find(pick => pick.user_id === this.user.id && this.getPlayWeek(pick.week_id) === this.weekInfo.play_week_num - 1);
                    if (!prev || prev.result !== 'won') {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        },
        hasPicked() {
            let pick = this.userPicks.filter(pick => pick.week_id === this.weekInfo.id).map(pickedPick => pickedPick.team_picked)[0];
            return pick ? true : false;
        },
        getTeamPicked() {
            if (this.weekInfo && this.userPicks) {
                let pick = this.userPicks.filter(pick => pick.week_id === this.weekInfo.id).map(pickedPick => pickedPick.team_picked)[0];
                return pick ? pick : 'No Team Picked';
            }
        },
        prevWeekId() {
            if (this.weeks) {
                return this.weeks.find(week => week.sd_game_id === this.weekInfo.sd_game_id && week.sd_round === this.weekInfo.sd_round - 1).id;
            }
        },
        numSurvivors() {
            if (this.weekInfo.sd_round === 1) {
                return '<br />New game! Everyone is alive!';
            } else {
                const num = this.currentGame.picks.filter(pick => pick.week_id === this.prevWeekId && pick.result === 'won').length;
                return 'Players still alive: ' + num;
            }
        }
    },
    methods: {
        setup() {
            this.pickedTeam = this.getTeamPicked;
            this.showMe = true;
        },
        getPlayWeek(week_id) {
            if (this.weeks) {
            return this.weeks.find(week => week.id === week_id).play_week_num;
            }
        },
    },
    created() {

        if (this.currentGame) {
            this.setup();
        }

        this.unwatchgame = this.$store.watch(
            (state, getters) => getters.currentGame,
            (newValue, oldValue) => {
                this.setup()
            }
        )

    },
    beforeDestroy() {
        this.unwatchgame();
    }
}
</script>

<style scoped>

    #sd-widj-box {
        border: 2px solid var(--v-secondary-base);
        background-color: #EFEBE9;
    }

    .link-btn {
        color: black !important;
    }

    #left-box {
        background-color: var(--v-secondary-base);
        color: #fff;
    }

    #right-top-box {
        background-color: #ddd;
        border-bottom: 1px solid #ccc;
    }

</style>
